import React, { useState, useRef, useEffect } from "react";
import Textbox from "carbon-react/lib/__experimental__/components/textbox";
import StepHeading from "../../common/stepHeading/StepHeading";
import StepTitle from "../../common/stepTitle/StepTitle";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../messages/SuccessMessage";
import ConfirmDialog from "../../common/confirmDialog/ConfirmDialog";

const EnterCodeStep = ({
  user,
  newEmail,
  busy,
  state,
  onStateChanged,
  onCancel,
  onCompleted,
  onBack,
}) => {
  const [confirmBackDialogOpen, setConfirmBackDialogOpen] = useState(false);
  const validationCodeInputRef = useRef(null);

  useEffect(() => {
    //  Set focus to the validation code input element
    if (!busy && isAValidFunc(validationCodeInputRef?.current?.focus)) {
      validationCodeInputRef.current.focus();
    }
  }, [busy]);

  const isAValidFunc = (func) => {
    return func && typeof func === "function";
  };

  const onCancelClicked = () => {
    if (isAValidFunc(onCancel)) onCancel();
  };

  const onChangeEmailClicked = () => {
    if (!validateStep()) return;
    if (isAValidFunc(onCompleted)) onCompleted();
  };

  const validateStep = () => {
    let result = true;
    if (!validateVerificationCode()) result = false;
    return result;
  };

  const validateVerificationCode = () => {
    const valid =
      state.verificationCode && state.verificationCode.length > 0
        ? true
        : false;
    updateState(() => {
      state.verificationCodeValid = valid;
    });
    return valid;
  };

  const verificationCodeWarningAttributes = {
    hasWarning: true,
    inputIcon: "warning",
    tooltipMessage: "Please enter a valid code",
  };

  const onVerificationCodeChanged = (code) => {
    const sanitizedCode = code && code.length > 0 ? code.trim() : "";
    updateState(() => {
      state.verificationCode = sanitizedCode;
      state.verificationCodeValid = true;
    });
  };

  const updateState = (mutateState) => {
    if (isAValidFunc(mutateState)) mutateState();
    onStateChanged({ ...state });
  };

  const verificationCodeInput = (
    <div className="change-email-verification-code">
      <Textbox
        id="change-email-verification-code"
        label="Verification code"
        disabled={busy}
        value={state?.verificationCode}
        inputRef={(e) => {
          validationCodeInputRef.current = e?.current;
        }}
        onChange={(e) => {
          onVerificationCodeChanged(e.target.value);
        }}
        onBlur={validateVerificationCode}
        {...(!state.verificationCodeValid
          ? verificationCodeWarningAttributes
          : {})}
      />
    </div>
  );

  const onBackClicked = () => {
    if (isAValidFunc(onBack)) {
      setConfirmBackDialogOpen(true);
    }
  };

  const onConfirmBackCancelClicked = () => {
    setConfirmBackDialogOpen(false);
  };

  const onConfirmBackAcceptClicked = () => {
    setConfirmBackDialogOpen(false);
    onBack();
  };

  return (
    <div id="enter-code-step" className="change-email-enter-code-step">
      <div className="change-email-step-body">
        <StepHeading label="Current email address" value={user.email} />
        <SuccessMessage
          className="code-sent-success-message"
          message={`Verification code was sent to ${newEmail}`}
        />
        <StepTitle title="Enter verification code" />
        {verificationCodeInput}
      </div>
      <DialogConfirmButtons
        appearBusy={busy}
        confirmBtnEnabled={true}
        confirmBtnLabel="Change email address"
        onConfirm={onChangeEmailClicked}
        onCancel={onCancelClicked}
        showBackBtn={true}
        backBtnLabel="Previous"
        onBack={onBackClicked}
      />
      <ConfirmDialog
        open={confirmBackDialogOpen}
        prompt="Continuing will render the last code void. Only use this option if you
        need to change the information provided, or send a new code."
        confirmBtnLabel="Continue"
        onConfirm={onConfirmBackAcceptClicked}
        onCancel={onConfirmBackCancelClicked}
      />
    </div>
  );
};

export default EnterCodeStep;
